import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { publicRequest } from './publicRequest'

export const resaleTicket = async (
  data: FormData,
  hash: string
): Promise<IResaleTicketResponse> => {
  const response: AxiosResponse<IResaleTicketResponse, AxiosRequestConfig> =
    await publicRequest.post(`v1/ticket/${hash}/sell`, data)

  return response.data
}

export const removeFromResale = async (
  hash: string
): Promise<IRemoveFromResaleResponse> => {
  const response: AxiosResponse<IRemoveFromResaleResponse, AxiosRequestConfig> =
    await publicRequest.delete(`v1/ticket/${hash}/sell`)

  return response.data
}

export const processTicket = (hash: string) =>
  publicRequest.post(`v1/ticket/${hash}/process`)

export const declineInvitation = (hash: string) =>
  publicRequest.post(`v1/ticket/${hash}/decline`)
